import { TypeM3PrdGrp } from "../Maestro/M3PrdGrp.type";
import { M3PrdPackByTipo } from "../Maestro/m3-pack-by-tipo";
import { M3PackByReglas } from "../Maestro/m3-pack-by-reglas";
import { Injectable } from "@angular/core";
import { M3PItemsWEB } from "../Registro/m3-pdetalle-items";
@Injectable({
    providedIn: 'root'
})
export class ServiceM3PackByipo {


    private operators = {
        '<': function (a, b) { return +a < +b },
        '>': function (a, b) { return +a > +b },
        '<=': function (a, b) { return +a <= +b },
        '>=': function (a, b) { return +a >= +b },
        'IGUAL': function (a, b) { return a == b },
        'DIFF': function (a, b) { return a != b },
        'EN': function (a, b) { return a === b },
        'AND': function (a, b) { return a && b },
        'OR': function (a, b) { return a || b },
        '*': function (a, b) { return true },
        'MOD': function (a, b) { return +a % +b == 0 },
        // ...
    };


    /**
     * Validar si el producto que serÃ¡ hijo, cumple con las caracteristicas
     * @param m3ProcPKG 
     * @param producto 
     */
    public ValidarSiEsTipo(m3ProcPKG: TypeM3PrdGrp, producto: TypeM3PrdGrp) {
        try {
            if (m3ProcPKG.M3PACKBYTIPO.find(x => x.DESTINO == producto.TIPO)) {
                return true;
            } else {
                return false;
            }
        } catch{
            return false;
        }

    }


    /**
     * Aplicacion de reglas de paquetes, teniendo en cuenta al informaciÃ³n del producto ingresado.
     * @param m3ProcPKG 
     * @param producto 
     * @param oM3PItemsWEB 
     */
    public GeneraValidaciones(m3ProcPKG: TypeM3PrdGrp, producto: TypeM3PrdGrp, oM3PItemsWEB: M3PItemsWEB) {
        try {
            var bResp:boolean = true;
            var oM3PACKBYTIPO: M3PrdPackByTipo = m3ProcPKG.M3PACKBYTIPO.find(x => x.DESTINO == producto.TIPO);
            if (oM3PACKBYTIPO) {
                for (var i = 0; oM3PACKBYTIPO.M3PACKREGLAS.length; i++) {
                    var oM3PackByReglas: M3PackByReglas = oM3PACKBYTIPO.M3PACKREGLAS[i];
                    //Se esta validando el papa del paquete.
                    if(this.operators[oM3PackByReglas.Operacion](this.GetParametros(oM3PackByReglas.Param1, m3ProcPKG) , this.GetParametros(oM3PackByReglas.Param2, m3ProcPKG))){
                        this.ValidacionAccion(oM3PackByReglas.Accion, oM3PItemsWEB);
                    }else{
                        bResp = false;
                    }
                }
            }
        } catch{

        }
        return bResp;
    }

    /**
     * ValidaciÃ³n de accion de reglas de paquete.
     * @param sAccion 
     */
    private ValidacionAccion(sAccion:string, oM3PItemsWEB:M3PItemsWEB){
        try{
            if(sAccion != "") {
                var oAccion:any = JSON.parse(sAccion);
                if(oAccion.Accion){
                    switch(oAccion.Accion){
                        case "Cantidad":
                            oM3PItemsWEB.dCantidad = oAccion.Valor;
                            break;
                    }
                }
            }
        }catch(ex){

        }
        


    }


    /**
     * Obtener informaciÃ³n de parametros, teniendo en cuenta las reglas.
     * @param parametro 
     * @param producto 
     */
    private GetParametros(parametro: string, producto: TypeM3PrdGrp) {
        var sParam: string = "";
        try {
            var regla: string = parametro.split("_")[0];
            switch (regla.toUpperCase()) {
                case "ADI":
                    sParam = producto.LoM3PrdAdicionales.find(x => x.ATRIBUTO == parametro.split("_")[1]).VALOR;
                    break;
                case "CONST":
                    sParam = parametro.split("_")[1];
                    break;
                default:
                    if(regla.toUpperCase().startsWith("SKP") ){
                        sParam = producto.LoM3PrdGeneral[0][regla];
                    }
                    break;
            }
        } catch{

        }
        return sParam;
    }



}